/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: _lT-Lq7an5i5
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicContainerInTab.module.css"; // plasmic-import: _lT-Lq7an5i5/css

createPlasmicElementProxy;

export const PlasmicContainerInTab__VariantProps = new Array(
  "padding",
  "bgColor"
);

export const PlasmicContainerInTab__ArgProps = new Array("children");

const $$ = {};

function PlasmicContainerInTab__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "padding",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.padding
      },
      {
        path: "bgColor",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.bgColor
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootbgColor_globalBg]: hasVariant($state, "bgColor", "globalBg"),
          [sty.rootbgColor_light]: hasVariant($state, "bgColor", "light"),
          [sty.rootbgColor_secondaryBg]: hasVariant(
            $state,
            "bgColor",
            "secondaryBg"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxbgColor_globalBg]: hasVariant(
            $state,
            "bgColor",
            "globalBg"
          ),
          [sty.freeBoxbgColor_light]: hasVariant($state, "bgColor", "light"),
          [sty.freeBoxbgColor_secondaryBg]: hasVariant(
            $state,
            "bgColor",
            "secondaryBg"
          ),
          [sty.freeBoxpadding_global]: hasVariant($state, "padding", "global"),
          [sty.freeBoxpadding_none]: hasVariant($state, "padding", "none")
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.children
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContainerInTab__ArgProps,
          internalVariantPropNames: PlasmicContainerInTab__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContainerInTab__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicContainerInTab";
  } else {
    func.displayName = `PlasmicContainerInTab.${nodeName}`;
  }
  return func;
}

export const PlasmicContainerInTab = Object.assign(
  // Top-level PlasmicContainerInTab renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    // Metadata about props expected for PlasmicContainerInTab
    internalVariantProps: PlasmicContainerInTab__VariantProps,
    internalArgProps: PlasmicContainerInTab__ArgProps
  }
);

export default PlasmicContainerInTab;
/* prettier-ignore-end */
